import { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import jsPDF from 'jspdf';
import 'jspdf-autotable'; // Import the jsPDF autoTable plugin
import PropTypes from 'prop-types'; 

const ReportTemplateSHEET = ({ dataSHEET, initialStateSheet, setDataSHEET, setViewPDF }) => {
  const { t } = useTranslation(['listDataForms']);
  function getDateFormated(getDate) {
    const meses = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const hoy = (getDate !==null && getDate !=="")? new Date(getDate):new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const año = hoy.getFullYear();
    return `${dia}-${mes}-${año}`;
  }
  function formatNumberK(num) {
    return num.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
  }
  const drawCheckbox = (doc, x, y, size = 10, checked = false) => {
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(1);   
    doc.setFillColor('white');
    doc.rect(x, y, size, size);
    if (checked) {
      doc.line(x + 2, y + 2, x + size - 2, y + size - 2);
      doc.line(x + size - 2, y + 2, x + 2, y + size - 2);
    }
  };
  const drawCheckbox16 = (doc, x, y, checked = false) => {
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(1);   
    doc.setFillColor('white');
    doc.rect(x, y, 16, 16);
    if (checked) {
      doc.line(x+4, y+4, x + 12, y + 12);
      doc.line(x + 4, y+12, x+12, y + 4);
    }
  };

  useEffect(() => {
    const generatePDF = () => {
      const doc = new jsPDF({
        format: 'a4',
        unit: 'pt',
      });
      const pageWidth = doc.internal.pageSize.getWidth();
      const centerX = pageWidth / 2;

      // === Título ===
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text('FICHA DE DESCONTAMINACIÓN', centerX, 15, { align: 'center' });
      let y=36
       // === Cabecera simple ===
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('FECHA DE ENTRADA : ', 10, y);
      doc.text('NÚMERO ORDEN : ', 300, y);

      doc.text('MATRÍCULA : ', 10, y+16);
      doc.text('MARCA/MODELO : ', 175, y+16);
      doc.text('BASTIDOR : ', 408, y+16);

      // Valores
      doc.setFont('helvetica', 'normal');
      doc.text(getDateFormated(new Date(dataSHEET.date_sheet)), 170, y);
      doc.text(String(dataSHEET.num_sheet || ''), 420, y);

      doc.text(`${(dataSHEET.vehicle_sheet || '').substr(0, 15)}`, 78, y+16);
      doc.text(`${(dataSHEET.vehicle_marca+" "+ dataSHEET.vehicle_model|| '').substr(0, 24)}`, 267, y+16);
      
      doc.text(`${(dataSHEET.frame_sheet || '').substr(0, 19)}`, 579, y+16, 'right');
      // Coordenadas base para estados
      
      // ESTADO DEL VEHÍCULO
      doc.setFont('helvetica', 'bold');
      doc.text('ESTADO DEL VEHÍCULO :', 10, y+36);
      doc.text('ENTERO', 175,  y+36);
      doc.text('PARCIALMENTE DESMONTADO', 272,  y+36);
      doc.text('SINIESTRADO', 497,  y+36);
      drawCheckbox(doc, 220,  y+26, 12,dataSHEET.sheetStatus_id===1);
      drawCheckbox(doc, 430, y+26, 12,dataSHEET.sheetStatus_id===2);
      drawCheckbox(doc, 570, y+26, 12, dataSHEET.sheetStatus_id===3);
      
      // PRODUCTOS LÍQUIDOS DEL VEHÍCULO
      y=94;
      for (let i = 0; i < 4; i++) {
          const it = dataSHEET.productliquidLinesheet[i] || {};
          doc.setFont('helvetica', 'bold');
          doc.text(it.productliquid_namees|| '', 10, y);
          doc.setFont('helvetica', 'normal');
          let amount = (it.amount)?formatNumberK(it.amount):"";
          doc.text(amount, 284, y, 'right');
          drawCheckbox(doc, 288, y - 10, 12,it.isSelected || false);
          y=y+16  
      }
      y=94;
      for (let i = 4; i < 8; i++) {
        const it = dataSHEET.productliquidLinesheet[i] || {};
        doc.setFont('helvetica', 'bold');
        doc.text(it.productliquid_namees|| '', 310, y);
        doc.setFont('helvetica', 'normal');
        let amount = (it.amount)?formatNumberK(it.amount):"";
        doc.text(amount, 566, y, 'right');
        drawCheckbox(doc, 570, y - 10, 12, it.isSelected || false);
        y=y+16
      }
      y=170;
      // PRODUCTOS DEL VEHÍCULO
      doc.setFont('helvetica', 'bold');
      doc.text('DESCONTAMINACIÓN', centerX, y-5, { align: 'center' });
      doc.setLineWidth(1);   
      doc.setFillColor('white');
      doc.rect(10, y, 213, 16, 'FD'); 
      doc.rect(223, y, 90, 16, 'FD');
      doc.rect(313, y, 90, 16, 'FD');
      doc.rect(403, y, 90, 16, 'FD');
      doc.rect(493, y, 90, 16, 'FD');
      doc.text('PRODUCTO', 116, y+12, { align: 'center' });
      doc.text('NO', 268, y+12, { align: 'center' });
      doc.text('PESO', 358, y+12, { align: 'center' });
      doc.text('REPUESTOS', 448, y+12, { align: 'center' });
      doc.text('RESIDUO', 538, y+12, { align: 'center' });
      y=186
      for (let i = 0; i < 40; i++) {
        const it = dataSHEET.productLinesheet[i] || {}; 
        doc.setLineWidth(1);  
        doc.setFillColor('white');
        doc.rect(10, y, 213, 16, 'FD'); 
        doc.rect(223, y, 74, 16, 'FD');
        drawCheckbox16(doc, 297, y , it.isSelectedNo || false);
        doc.rect(313, y, 74, 16, 'FD');
        drawCheckbox16(doc, 387, y , it.isSelectedWeigth || false);
        doc.rect(403, y, 74, 16, 'FD');
         drawCheckbox16(doc, 477, y , it.isSelectedSpare || false);
        doc.rect(493, y, 74, 16, 'FD');
        drawCheckbox16(doc, 567, y , it.isSelectedResidue || false);
        doc.setFont('helvetica', 'bold');
        doc.text(it.product_namees|| '', 12, y+12);
        doc.setFont('helvetica', 'normal');
        let amountNo = (it.amountNo)?formatNumberK(it.amountNo):"";
        let amountWeight = (it.amountWeight)?formatNumberK(it.amountWeight):"";
        let amountSpare = (it.amountSpare)?formatNumberK(it.amountSpare):"";
        let amountResidue = (it.amountResidue)?formatNumberK(it.amountResidue):"";
        doc.text(amountNo, 293, y+12, 'right');
        doc.text(amountWeight, 383, y+12, 'right');
        doc.text(amountSpare, 473, y+12, 'right');
        doc.text(amountResidue, 563, y+12, 'right'); 
        y=y+16
      }
 
       
    // Open PDF in a new tab
    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, '_blank');
    setViewPDF(false);
    setDataSHEET(initialStateSheet); 

  };

  if (dataSHEET) {
    generatePDF();
  }
}, [dataSHEET, t,setViewPDF, setDataSHEET, initialStateSheet]);
  return null; // This component does not render anything in the DOM
};

ReportTemplateSHEET.propTypes = {
  dataSHEET: PropTypes.object.isRequired, 
  setDataSHEET: PropTypes.func.isRequired,
  setViewPDF: PropTypes.func.isRequired
};

export default ReportTemplateSHEET;
